export default function () {
    return <>
        <div style='display: flex; justify-content: center; margin-top: 3rem'>
            <h2>Vous n'êtes pas autorisé à accèder à ce contenu.</h2>
        </div>
    </>
}
